export default function animate() {

    const gsap = window['ikosGsap'];

    if ( document.querySelector('.elementor-editor-active') || ! gsap ) {
        console.warn( 'Something is wrong with animation setup' );
        return;
    }


    const ikos__anim_img_from_up = gsap.utils.toArray('.ikos__img_clip_from_top');
    ikos__anim_img_from_up.forEach(item => {
        gsap.from(item, {
            scrollTrigger: {
                trigger: item,
                start: "top 85%",
                end: "top 50%",
                toggleClass: 'animate',
                once: true
            },
        });
    });

    const ikos__anim_in_left = gsap.utils.toArray('.ikos__anim_in_left');
    ikos__anim_in_left.forEach(item => {
        gsap.to(item, {
            scrollTrigger: {
                trigger: item,
                start: "top 85%",
                end: "top 50%",
                toggleClass: 'animated',
                once: true
            }
        });
    });


    function getTranslate( dir, amount ) {

        const translate = {};

        if ( dir === 'up' ) {
            translate.y = amount;
        }

        if ( dir === 'down' ) {
            translate.y = -amount;
        }

        if ( dir === 'right')  {
            translate.x = -amount;
        }

        if ( dir === 'left')  {
            translate.x = amount;
        }

        return translate;
    }

    function getScrollTrigger ( trigger ) {
        return {
            trigger,
            start: "top 85%",
            end: "top 50%",
            toggleClass: 'animated',
            once: true
        }
    }



    [ 'up', 'down', 'left', 'right' ].forEach( ( dir ) => {
        [ 50, 100, 150, 200, 300 ].forEach( ( amount ) => {
            const token = '.ikos__anim_fade';

            const animations = gsap.utils.toArray(`${token}_${dir}_${amount}`);

            animations.forEach( item => {
                const scrollTrigger = getScrollTrigger( item );
                const translate = getTranslate( dir, amount );

                const settings = {
                    scrollTrigger,
                    duration: 0.7,
                    autoAlpha: 0,
                    ease: "power1.inOut",
                    ...translate
                }

                gsap.from( item, settings );

            } )

        })
    });

    const ikos__anim_fade_in = gsap.utils.toArray('.ikos__anim_fade_in');
    ikos__anim_fade_in.forEach( item => {
        const scrollTrigger = getScrollTrigger( item );
        gsap.from( item, {
            scrollTrigger,
            duration: 0.7,
            autoAlpha: 0,
            ease: "power1.inOut",
        } );

    } )


    const ikos__anim_scroll_up_50 = gsap.utils.toArray('.ikos__anim_scroll_up_50');
    ikos__anim_scroll_up_50.forEach(item => {
        gsap.to(item, {
            scrollTrigger: {
                trigger: item,
                start: "top-=100px 85%",
                end: "bottom 10%",
                scrub: 1,
            },
            y: '-50%',
        });
    });

    const ikos__anim_scroll_up_100 = gsap.utils.toArray('.ikos__anim_scroll_up_100');
    ikos__anim_scroll_up_100.forEach(item => {
        gsap.to(item, {
            scrollTrigger: {
                trigger: item,
                start: "top-=100px 85%",
                end: "bottom 30%",
                //markers: true,
                scrub: 1,
            },
            y: '-100%',
        });
    });

    const ikos__anim_scroll_right = gsap.utils.toArray('.ikos__anim_scroll_right');
    ikos__anim_scroll_right.forEach(item => {
        gsap.set( item, {
            xPercent: -10
        } );
        gsap.to(item, {
            scrollTrigger: {
                trigger: item,
                start: "top-=100px 95%",
                end: "center 25%",
                scrub: 1,
            },
            xPercent: 0
        });
    });

    const ikos__anim_scroll_left = gsap.utils.toArray('.ikos__anim_scroll_left');
    ikos__anim_scroll_left.forEach(item => {
        gsap.set( item, {
            xPercent: 10
        } );
        gsap.to(item, {
            scrollTrigger: {
                trigger: item,
                start: "top-=100px 95%",
                end: "center 25%",
                scrub: 1,
            },
            xPercent: 0
        });
    });

    const ikos__anim_scroll_up = gsap.utils.toArray('.ikos__anim_scroll_up');
    ikos__anim_scroll_up.forEach(item => {
        gsap.set( item, {
            yPercent: 15,
        } );
        gsap.to(item, {
            scrollTrigger: {
                trigger: item,
                start: "top 95%",
                end: "center 25%",
                scrub: 1,
            },
            yPercent: 0,
        });
    });

    const ikos__anim_scroll_up_right = gsap.utils.toArray('.ikos__anim_scroll_up_right');
    ikos__anim_scroll_up_right.forEach(item => {
        gsap.set( item, {
            yPercent: 15,
            xPercent: -10
        } );
        gsap.to(item, {
            scrollTrigger: {
                trigger: item,
                start: "top 95%",
                end: "center 25%",
                scrub: 1,
            },
            yPercent: 0,
            xPercent: 0
        });
    });

    const ikos__anim_scroll_up_left = gsap.utils.toArray('.ikos__anim_scroll_up_left');
    ikos__anim_scroll_up_left.forEach(item => {
        gsap.set( item, {
            yPercent: 15,
            xPercent: 10
        } );
        gsap.to(item, {
            scrollTrigger: {
                trigger: item,
                start: "top-=100px 95%",
                end: "center 25%",
                scrub: 1,
            },
            yPercent: 0,
            xPercent: 0
        });
    });

    const ikos__anim_scroll_down_right = gsap.utils.toArray('.ikos__anim_scroll_down_right');
    ikos__anim_scroll_down_right.forEach(item => {
        gsap.set( item, {
            yPercent: -15,
            xPercent: -10
        } );
        gsap.to(item, {
            scrollTrigger: {
                trigger: item,
                start: "top-=100px 95%",
                end: "center 25%",
                scrub: 1
            },
            yPercent: 0,
            xPercent: 0
        });
    });

    const ikos__anim_scroll_down_left = gsap.utils.toArray('.ikos__anim_scroll_down_left');
    ikos__anim_scroll_down_left.forEach(item => {
        gsap.set( item, {
            yPercent: -15,
            xPercent: 10
        } );
        gsap.to(item, {
            scrollTrigger: {
                trigger: item,
                start: "top-=100px 95%",
                end: "center 25%",
                scrub: 1,
            },
            yPercent: 0,
            xPercent: 0
        });
    });
}
